import React from 'react';
import cls from './WidthLimiter.module.scss'

export const WidthLimiter = ({children}) => {
  return (
    <div className={cls.wrapper}>
      {children}
    </div>
  );
};